import * as React from "react";
import {useSelector} from "react-redux";
import {Redirect, Route, RouteComponentProps, Switch} from "react-router";
import {map} from "lodash";
import {apAppLink, apAppPath} from "@web2/ap-routes";

import {ApplicationsView} from "../applications/views/ApplicationsView";
import {LoginView} from "../login/view/LoginView";
import {LogoutView} from "../login/view/LogoutView";
import {NewPasswordView} from "../login/view/NewPasswordView";
import {ResetPasswordView} from "../login/view/ResetPasswordView";
import {AuthenticatedRoute} from "./components/AuthenticatedRoute";
import {IAPStore} from "./reducers/ap_reducer";
import {NotFoundView} from "./views/NotFoundView";

const HomePageRedirect = () => {
    const isAuthenticated = useSelector((store: IAPStore) => store.account.isAuthenticated);

    return <Redirect to={isAuthenticated ? apAppLink.applications() : apAppLink.login()} />;
};

const routes: IVisualRoute[] = [
    // unauthorized routes
    {
        path: apAppPath.base,
        component: HomePageRedirect,
        allowUnauthenticatedUsers: true
    },
    {path: apAppPath.login, component: LoginView, allowUnauthenticatedUsers: true},
    {path: apAppPath.logout, component: LogoutView, allowUnauthenticatedUsers: true},
    {path: apAppPath.passwordReset, component: ResetPasswordView, allowUnauthenticatedUsers: true},
    {path: apAppPath.newPassword, component: NewPasswordView, allowUnauthenticatedUsers: true},

    // authorized routes
    {path: apAppPath.applications, component: ApplicationsView},

    // 404
    {component: NotFoundView, allowUnauthenticatedUsers: true}
];

interface IVisualRoute {
    path?: string | string[];
    exact?: false;
    component: React.ComponentType<IRouteComponentProps>;
    allowUnauthenticatedUsers?: boolean;
}
export interface IRouteComponentProps extends RouteComponentProps {}

export const Routes = () => {
    return (
        <Switch>
            {map(routes, (route, idx) =>
                route.allowUnauthenticatedUsers ? (
                    <Route key={idx.toString()} path={route.path} exact={route.exact !== false} strict component={route.component} />
                ) : (
                    <AuthenticatedRoute key={idx.toString()} path={route.path} exact={route.exact !== false} strict component={route.component} />
                )
            )}
        </Switch>
    );
};
